module.exports = __webpack_public_path__ + "img/scan-boot.47ed49c8.jpg";